import styled from 'styled-components';

export const AddToEstimateIcon = styled.div`
  width: fit-content;
  height: fit-content;
`;
